(function($) {
  
  $(document).ready(function(){
    $('.owl-dot.c-carousel__dot').append('<p class="u-visuallyhidden">a11y</p>');


    // Creates labels for select created to polyfill input date
      var $yearSelectPolyfill = $('date-input-polyfill select.yearSelect');
      var $monthSelectPolyfill = $('date-input-polyfill select.monthSelect');

      $yearSelectPolyfill.attr('id', 'datePolyfill-yearSelect');
      $monthSelectPolyfill.attr('id', 'datePolyfill-monthSelect');

      $('date-input-polyfill .yearSelect-wrapper').prepend('<label for="datePolyfill-yearSelect" class="u-visuallyhidden">Anno</label>')
      $('date-input-polyfill .monthSelect-wrapper').prepend('<label for="datePolyfill-monthSelect" class="u-visuallyhidden">Mese</label>')

  });

})(jQuery);